import axios from "axios";
import moment from 'moment';
import qs from 'qs'
export default {
    namespaced: true,
    state: {
        loading: false,
        banner: {},
        bannerList: [],
        bannerDetails: {}
    },
    mutations: {
        updateBannerData(state, data) {
            state.banner = { ...state.banner, ...data };
        },
        updateBannerList(state, data) {
            state.bannerList = data;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setBannerDetails(state, data) {
            state.bannerDetails = data;
        }
    },
    actions: {
        saveBannerData({ commit }, payload) {
            commit('updateBannerData', payload);
        },
        postCreateBanner({ state }, banner) {
            const formData = new FormData();
            Object.keys(banner).forEach((key) => {
                if (banner[key]) {
                    if (key === 'endDate') {
                        const splittedEndDate = banner[key].split(/[- :]/)
                        let endDate = splittedEndDate[2] + '/' + splittedEndDate[1] + '/' + splittedEndDate[0]
                        endDate = endDate ? moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : endDate
                        formData.append(key, endDate);
                    }
                    else formData.append(key, banner[key]);
                }
            });

            return axios
                .post(`/api/panel/banner`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((response) => {
                    return response.data;
                })
                .catch((err) => {
                    throw err;
                });
        },
        getBanners({ commit }, banner) {
            commit("setLoading", true);

            let query = {
                page: banner.pageNumber,
                size: banner.pageSize,
                search: banner.search,
                startDate: banner.startDate,
                endDate: banner.endDate,
                isActive: banner.isActive,
                applicationType: banner.applicationType,
                sortType: banner.sortType,
                sortingColumn: banner.sortingColumn
            }
            if (query.startDate) {
                const splittedStartDate = query.startDate.split(/[- :]/)
                let startDate = splittedStartDate[2] + '/' + splittedStartDate[1] + '/' + splittedStartDate[0]
                query.startDate = startDate ? moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : startDate
            }
            if (query.endDate) {
                const splittedEndDate = query.endDate.split(/[- :]/)
                let endDate = splittedEndDate[2] + '/' + splittedEndDate[1] + '/' + splittedEndDate[0]
                query.endDate = endDate ? moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : endDate
            }
            const queryString = qs.stringify(query,
                {
                    skipNulls: true,
                    filter: (prefix, value) => (value !== '' ? value : undefined),
                });

            return axios
                .get(
                    `/api/panel/banner/get-all?${queryString}`
                )
                .then((response) => {
                    commit("updateBannerList", response.data.payload.items);
                    commit("setLoading", false);

                    return response.data.payload;
                });
        },
        getBannerDetails({ commit }, bannerId) {
            return axios
                .get(`/api/panel/banner/${bannerId}`)
                .then((response) => {
                    if(response.data.payload && response.data.payload.endDate){
                        response.data.payload.endDate = response.data.payload.endDate.substring(0, 10)
                    }
                    commit("setBannerDetails", response.data.payload);
                    return response.data.payload;
                }).catch(err => {
                    throw false;
                });
        },
        updateBanner({ state }, banner) {
            const formData = new FormData();
            Object.keys(banner).forEach((key) => {
                if (banner[key]) {
                    if (key === 'endDate') {
                        const splittedEndDate = banner[key].split(/[- :]/)
                        let endDate = splittedEndDate[2] + '/' + splittedEndDate[1] + '/' + splittedEndDate[0]
                        endDate = endDate ? moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : endDate
                        formData.append(key, endDate);
                    }
                    else formData.append(key, banner[key]);
                }
            });

            return axios
                .put(`/api/panel/banner/${banner.id}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((response) => {
                    return response.data;
                })
                .catch((err) => {
                    throw err;
                });
        },
        deleteBanner({ commit }, bannerId) {
            return axios
                .delete(`/api/panel/banner/${bannerId}`)
                .then(() => {
                    return true;
                }).catch(() => {
                    return false
                });
        },
    },
    getters: {
        getBannerData: (state) => () => state.banner,
        bannerList: (state) => state.bannerList,
        loading: (state) => state.loading,
        bannerDetails: (state) => state.bannerDetails
    },
};
